(function () {
  'use strict';
  var header = document.querySelector('[data-gp-header]');
  var nav = document.querySelector('[data-mobile-nav]');
  var toggle = document.querySelector('[data-menu-toggle]');
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  function updateHeaderHeight() {
    if (header) document.documentElement.style.setProperty('--gp-header-height', Math.ceil(header.getBoundingClientRect().height) + 'px');
  }
  updateHeaderHeight();
  if (header && 'ResizeObserver' in window) new ResizeObserver(updateHeaderHeight).observe(header);
  function closeDropdowns(except) {
    document.querySelectorAll('.gp-discovery-nav details[open]').forEach(function (item) { if (item !== except) item.open = false; });
  }
  document.addEventListener('click', function (event) {
    if (!event.target.closest('.gp-discovery-nav')) closeDropdowns();
    if (event.target.closest('.gp-nav-dropdown a')) closeDropdowns();
    var button = event.target.closest('[data-gp-rail]');
    if (button) {
      var rail = document.getElementById(button.getAttribute('data-gp-rail'));
      if (rail) {
        var card = rail.querySelector('[data-product-card]');
        var gap = parseFloat(getComputedStyle(rail).columnGap) || 0;
        var distance = card ? card.getBoundingClientRect().width + gap : rail.clientWidth;
        rail.scrollBy({ left: distance * Number(button.getAttribute('data-direction')), behavior: reducedMotion.matches ? 'auto' : 'smooth' });
      }
    }
    var link = event.target.closest('a[data-gp-discovery],.gp-discovery-nav a,.gp-mobile-discovery-nav a,.gp-discovery-chips a,.gp-discovery-all,.gp-discovery-text-link');
    if (link && window.GamePulseEvents) window.GamePulseEvents.emit('catalog_discovery', { placement: link.getAttribute('data-gp-discovery') || 'catalog_navigation', category: link.getAttribute('data-discovery-label') || '', label: link.textContent.trim().slice(0, 80) });
  });
  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      var activeSummary = document.activeElement.closest('.gp-nav-disclosure');
      closeDropdowns();
      if (activeSummary) activeSummary.querySelector('summary').focus();
    }
    if (event.key === 'Tab' && nav && !nav.hidden) {
      var controls = Array.from(nav.querySelectorAll('a,button,summary')).filter(function (node) { return node.getClientRects().length > 0 && !node.disabled; });
      if (!controls.length) return;
      var first = controls[0];
      var last = controls[controls.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    }
  });
  if (nav) new MutationObserver(function () {
    if (!nav.hidden) {
      closeDropdowns();
      var close = nav.querySelector('[data-menu-close]');
      if (close) close.focus();
    } else if (nav.contains(document.activeElement) && toggle) toggle.focus();
  }).observe(nav, { attributes: true, attributeFilter: ['hidden'] });
  document.querySelectorAll('[data-gp-rail]').forEach(function (button) {
    var rail = document.getElementById(button.getAttribute('data-gp-rail'));
    if (!rail) return;
    function update() {
      var max = rail.scrollWidth - rail.clientWidth;
      button.disabled = Number(button.getAttribute('data-direction')) < 0 ? rail.scrollLeft <= 2 : rail.scrollLeft >= max - 2;
    }
    rail.addEventListener('scroll', update, { passive: true });
    if ('ResizeObserver' in window) new ResizeObserver(update).observe(rail);
    update();
  });
}());
